import { useEffect, useCallback, useRef } from "react";
import { useConsentStore } from "@/store/consentStore";

const GA_ID = "G-PLLP3KQ1M4";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function loadGtag() {
  if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function useAnalytics() {
  const consent = useConsentStore((s) => s.analyticsConsent);
  const loaded = useRef(false);

  useEffect(() => {
    if (consent === "accepted" && !loaded.current) {
      loadGtag();
      loaded.current = true;
    }
  }, [consent]);

  const trackEvent = useCallback(
    (name: string, params?: Record<string, unknown>) => {
      if (typeof window.gtag === "function") {
        window.gtag("event", name, params);
      }
    },
    [],
  );

  return { trackEvent };
}
